import {useMutation, useQueryClient} from '@tanstack/react-query'

import {dispatchKeys} from 'src/dispatch/query-keys'
import {invalidateEquipmentMoves} from 'src/project-deployed-equipment/invalidate-equipment-moves'

import {confirmRentalsOut} from './api'

export function useConfirmRentalsOut() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (rentalStintIds: string[]) => confirmRentalsOut({rentalStintIds}),
        onSuccess: () => {
            void invalidateEquipmentMoves(queryClient, null)
            void queryClient.invalidateQueries({queryKey: dispatchKeys.all})
        },
    })
}
